module.exports = __webpack_public_path__ + "img/logo-hotelv-fizeaustraat.0b0959b63483ad9e1f01c675d264fa67.svg";